// Find a module's permission flags in the /api/me module tree.
export function findPerm(modules, key) {
  for (const m of modules) {
    if (m.key === key) return m;
    for (const c of m.children) if (c.key === key) return c;
  }
  return { can_view: false, can_create: false, can_edit: false, can_delete: false };
}
